
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1722848046898",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "4292",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "16",
    "height": "16"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M0.512208 0.511744h1023.391792v248.707522H0.512208V0.511744z m0 303.97586h307.014339v331.610029H0.512208V304.487604z m0 386.878367h307.014339v331.610029H0.512208V691.365971zM358.700934 304.487604h307.01434v331.610029H358.700934V304.487604z m0 386.878367h307.01434v331.610029H358.700934V691.365971zM716.889661 304.487604h307.014339v331.610029H716.889661z m0 386.878367h307.014339v331.610029H716.889661z",
        "p-id": "4293"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M0.512208 0.511744h1023.391792v248.707522H0.512208V0.511744z m0 303.97586h307.014339v331.610029H0.512208V304.487604z m0 386.878367h307.014339v331.610029H0.512208V691.365971zM358.700934 304.487604h307.01434v331.610029H358.700934V304.487604z m0 386.878367h307.01434v331.610029H358.700934V691.365971zM716.889661 304.487604h307.014339v331.610029H716.889661z m0 386.878367h307.014339v331.610029H716.889661z",
        "p-id": "4294"
      }
    }
  ]
})
    }
  